import React, { useState } from "react";
import cloudNowLogo from "../../../assets/images/cnwlogo.png";
import dayjs from "dayjs";
import "./ResignationApproval.scss";
import Loader from "../../../components/Loader/Loader";
import { useSearchParams } from "react-router-dom";

const JobDescription = () => {
  const [searchParams] = useSearchParams();
  const { employeeId, designationId, designationName, reportingManagerId, organisationId, employeeApiKey, organisationLogo } = Object.fromEntries(searchParams.entries());


  const [loader, setLoader] = useState(false);


  return (
    <div className="basicForm-page">
      {loader && <Loader />}

      <div>
        <div className=" flex justify-center items-center ">
          <div className="w-full lg:w-3/5  bg-white my-5 py-16 px-7 lg:px-14 basic-info-start mx-[5px] lg:mx-auto">
            <div className="flex justify-between items-center  pb-14 ">
              <img src={organisationLogo || cloudNowLogo} alt="cloudNowLogo" className="w-[150px] lg:w-auto " />
              <p className=" pt-[2px] lg:pt-0">Date: {dayjs().format("DD/MM/YYYY")}</p>
            </div>

            <div>
              <h2 className="text-center text-xl md:text-3xl font-bold pb-6">Job Description</h2>
              <table className="w-full border-collapse border border-gray-300 mb-6">
                <tr className="border border-gray-300">
                  <td className="p-3 font-semibold border-r">Role</td>
                  <td className="p-3">UI Developer (React)</td>
                </tr>
                <tr className="border border-gray-300">
                  <td className="p-3 font-semibold border-r">Experience</td>
                  <td className="p-3">2 - 3 years</td>
                </tr>
                <tr className="border border-gray-300">
                  <td className="p-3 font-semibold border-r">Compensation</td>
                  <td className="p-3">4 LPA - 6 LPA</td>
                </tr>
                <tr className="border border-gray-300">
                  <td className="p-3 font-semibold border-r">Job Location</td>
                  <td className="p-3">Chennai</td>
                </tr>
              </table>

              <h2 className="text-xl font-semibold text-gray-700 mb-3">Job Description:</h2>
              <p className="text-gray-600 mb-4">We are looking for a ReactJS developer having a minimum of 2 years of overall experience in web technologies and a minimum of 2 years of hands-on experience working on ReactJS technologies.</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Ability to analyze and design developments as per the requirements;</li>
                <li>Convert UX designs into responsive and user-friendly interfaces;</li>
                <li>Integrate back-end functions and interfaces with the UI;</li>
                <li>Autonomous and able to organize work based on priorities;</li>
                <li>Collaborate with the team to brainstorm and create new user-facing features;</li>
                <li>Work collaboratively with stakeholders to achieve goals;</li>
                <li>Stay updated with the latest technologies and development practices.</li>
              </ul>

              <h2 className="text-xl font-semibold text-gray-700 mt-6 mb-3">Responsibilities:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Work on ReactJS, TypeScript, HTML5, JavaScript, SCSS.</li>
                <li>Experience with ReactJS development is a must.</li>
                <li>Knowledge of Async programming.</li>
                <li>Build efficient reusable code, modules, and libraries.</li>
                <li>Optimize applications for speed and scalability.</li>
                <li>Test-driven development using unit-test tools.</li>
                <li>Strong knowledge of ReactJS, TypeScript, JavaScript, SCSS, AJAX, and client-side web programming.</li>
                <li>Understand functional design principles for scalable applications.</li>
                <li>Conceptual understanding of Web and RESTful APIs.</li>
                <li>Experience in multi-tier architecture and service-oriented architecture.</li>
                <li>Familiarity with modern frontend tooling.</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDescription;
